import { m } from "framer-motion";
import React, { useRef, useState } from "react";
import { Box, Container, Grid, Typography, Button, Stack } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";
import { styled } from "@mui/material/styles";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { MotionViewport, varFade, varZoom } from "../animate";

import "./homepage.css";
import Iconify from "../iconify";

export default function HomeSectionTwo() {
  const mdUp = useResponsive("up", "md");
  const handleFreeTrialClick = () => {
    const selectedPlan = "Free Trial"; // Only store the plan name

    sessionStorage.setItem("selectedPlan", selectedPlan);
    window.location.href = "/paymenthome"; // Redirect to the payment plan page
  };

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const FreeTrial = styled(Button)(({ theme }) => ({
    backgroundColor: "#C7F760",
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "& .icon-hover": {
      transition: "color 0.3s ease",
    },
    "&:hover": {
      backgroundColor: "#1E53E8",
      color: "#C7F760",
      "& .icon-hover": {
        color: "#FFFFFF", // Change the icon color to white on hover
      },
    },
  }));
  const getVideoHeight = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 600) {
        return 'auto'; // Mobile
    } else if (screenWidth > 600 && screenWidth <= 1024) {
        return '500px'; // Tablet
    } else {
        return '600px'; // Desktop
    }
};

  return (
    <Container
      maxWidth={false}
      sx={{
        pb: 10,
        mb: 3,
        mt: { xs: 5, md: 0 },
        zIndex: -2,
        backgroundImage: 'url("/assets/HomeSectionTwoBG.svg")',
        backgroundSize: "cover", // Adjust as needed
        backgroundPosition: "center", // Adjust as needed
      }}
      component={MotionViewport}
    >
      <Grid spacing={2} alignItems="center" sx={{ pt: { xs: 8 } }}>
        <m.div variants={varFade({ distance: 120, durationIn: 0.9 }).inUp}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            textAlign="center"
            component="p"
            sx={{
              fontSize: 16,
              fontFamily: "Roboto Flex",
              fontStyle: "italic",
              fontWeight: "600",
              textTransform: "uppercase",
            }}
            gutterBottom
          >
            A <span style={{ color: "#1E53E8" }}>SAFER DIGITAL</span> WORLD FOR
            KIDS
          </Typography>

          {mdUp && (
            <Typography
              variant="h2"
              marginBottom={1}
              className="heading3"
              textAlign="center"
              component="P"
              gutterBottom
            >
              YOUR CHILD'S SAFETY,
              <span style={{ color: "#1E53E8" }}> OUR PRIORITY </span>
            </Typography>
          )}
          {!mdUp && (
            <Typography
              variant="h4"
              marginBottom={1}
              className="heading3"
              textAlign="center"
              component="P"
              gutterBottom
            >
              YOUR CHILD'S SAFETY,
              <span style={{ color: "#1E53E8" }}> OUR PRIORITY </span>
            </Typography>
          )}
        </m.div>
      </Grid>
      <Stack
        direction="column"
        spacing={0}
        justifyContent="center"
        alignItems="center"
      >
        {/* <Container padding={0} > */}
        <Box
          sx={{
            position: "relative",
            // width: '100%',
            // maxWidth: '800px',
            m: { md: 0, sm: "25px 0px", xs: "25px 0px" },
            p: { md: "40px", sm: 0, xs: 0 },
          }}
          component={m.div}
          variants={varZoom({ distance: 80, durationIn: 0.9 }).in}
        >
          <video
            ref={videoRef}
            width="100%"
            height={getVideoHeight()}
            // height="auto"
            style={{ borderRadius: 15, border:'1px solid blue' }}
            onClick={handlePlayPause}
            controls={isPlaying}
            muted // Start muted; unmute when video is in view
            // autoPlay
            loop
          >
            <source src="/assets/Intro_video_homepage.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {!isPlaying && (
            <Button
              onClick={handlePlayPause}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "#fff",
                borderRadius: "50%",
                padding: "10px",
                minWidth: "60px",
                minHeight: "60px",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                },
              }}
            >
              <PlayArrowIcon fontSize="large" />
            </Button>
          )}
        </Box>
        {/* </Container> */}
      {mdUp &&  <Grid
          container
          component={m.div}
          variants={varFade({ distance: 120, durationIn: 1 }).inUp}
          md={4}
          justifyContent="center"
        >
          <FreeTrial
            onClick={handleFreeTrialClick}
            variant="contained"
            fullWidth
            size="large"
            sx={{
              color: "#1E53E8",
              fontWeight: "bold",
              background: "#C7F760",
              padding: 1,
              borderRadius: 2,
            }}
          >
            <Iconify
              icon="gg:microsoft"
              width="1.6em"
              height="1.6em"
              className="icon-hover"
            />
            &nbsp;Get Started for Free
          </FreeTrial>
        </Grid>}
      </Stack>
    </Container>
  );
}
